import { Trans } from "@lingui/react/macro";
import { useState } from "react";

import { ApiConnector } from "../../../api/api-connector";
import { Button } from "../../../components/ui-kit/button";
import { MfaEnrollment } from "../mfa/mfa-enrollment";

/**
 * The offer to set two-factor up, shown after a login that will soon need it.
 * The session is already issued, so both ways out open the app — this only
 * decides whether the user sets a method up on the way through.
 */
export function EnrollmentOffer({ api }: { api: ApiConnector }) {
  const [enrolling, setEnrolling] = useState(false);

  function openApp() {
    api.completeLogin();
  }

  if (enrolling) {
    return (
      <MfaEnrollment
        api={api}
        intro={
          <Trans>
            Scan this QR code with an authenticator app, then enter the code it
            shows.
          </Trans>
        }
        expiredMessage={<Trans>Setup expired before it was finished.</Trans>}
        onEnrolled={openApp}
        onCancel={openApp}
        cancelLabel={<Trans>Skip for now</Trans>}
      />
    );
  }

  return (
    <div className="flex flex-col items-center">
      <h2 className="text-xl font-semibold mb-4">
        <Trans>Set up two-factor authentication</Trans>
      </h2>

      <p className="text-sm text-center max-w-96">
        <Trans>
          Your account will require two-factor authentication soon. Setting it
          up now takes a minute, and you can keep working straight afterwards.
        </Trans>
      </p>

      <Button
        variant="primary"
        className="mt-6"
        onClick={() => {
          setEnrolling(true);
        }}
      >
        <Trans>Set up now</Trans>
      </Button>

      <a
        onClick={openApp}
        className="text-xs text-brand-primary hover:underline cursor-pointer mt-8"
      >
        <Trans>Skip for now</Trans>
      </a>
    </div>
  );
}
